export const getInfoObject = (infoWindow: any, airports: any, places: any) => {
  if (infoWindow.type === "airport")
    return airports.filter((airport: any) => airport.id === infoWindow.id)[0];
  return places.filter((place: any) => place.id === infoWindow.id)[0];
};
